import { cn } from './cn';

export const Spinner = ({ className }: { className?: string }) => (
  <span
    className={cn('inline-block h-4 w-4 animate-spin rounded-full border-2 border-line border-t-fg-soft', className)}
    aria-hidden="true"
  />
);

export default Spinner;
